import fetch from 'node-fetch';

/**
 * 
 * @param {*} body 
 * @returns 
 */
function post(body) {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'POST',
      body: JSON.stringify(body)
    };
    fetch('https://eventemitter.simplybenefits.ca', options).then(res => res.json()).then(() => {
      resolve('success');
    }).catch(err => {
      reject(err);
    });
  });
}
export default post;